import { render, staticRenderFns } from "./singleShift.vue?vue&type=template&id=702805d0&"
import script from "./singleShift.vue?vue&type=script&lang=js&"
export * from "./singleShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports